import { type IconComponentBaseProps } from '@/components/atoms/Icon/types';

import { defaultTheme } from '@/theme';

type FileCopyProps = IconComponentBaseProps;

export const FileCopy = ({
  className,
  width = 24,
  height = 24,
  fill = defaultTheme.mantineColors.gray[7],
}: FileCopyProps) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <g transform="translate(2.5 1.5) scale(1.5)">
        <path
          d="M10.7948 11.3333H3.87183C3.53506 11.3333 3.25 11.2167 3.01667 10.9833C2.78333 10.75 2.66667 10.4649 2.66667 10.1282V1.20517C2.66667 0.868389 2.78333 0.583333 3.01667 0.35C3.25 0.116667 3.53506 0 3.87183 0H8.00133C8.162 0 8.3165 0.0312221 8.46483 0.0936666C8.61306 0.156 8.74189 0.241889 8.85133 0.351334L11.6487 3.14867C11.7581 3.25811 11.844 3.38694 11.9063 3.53517C11.9688 3.6835 12 3.838 12 3.99867V10.1282C12 10.4649 11.8833 10.75 11.65 10.9833C11.4167 11.2167 11.1316 11.3333 10.7948 11.3333ZM11 4H8.80767C8.58122 4 8.39 3.922 8.234 3.766C8.078 3.61 8 3.41878 8 3.19233V1H3.87183C3.8205 1 3.7735 1.02139 3.73083 1.06417C3.68806 1.10683 3.66667 1.15383 3.66667 1.20517V10.1282C3.66667 10.1795 3.68806 10.2265 3.73083 10.2692C3.7735 10.3119 3.8205 10.3333 3.87183 10.3333H10.7948C10.8462 10.3333 10.8932 10.3119 10.9358 10.2692C10.9786 10.2265 11 10.1795 11 10.1282V4ZM1.20517 14C0.868389 14 0.583333 13.8833 0.35 13.65C0.116667 13.4167 0 13.1316 0 12.7948V4.5C0 4.35811 0.0478889 4.23933 0.143667 4.14367C0.239333 4.04789 0.358111 4 0.5 4C0.641889 4 0.760667 4.04789 0.856333 4.14367C0.952111 4.23933 1 4.35811 1 4.5V12.7948C1 12.8462 1.02139 12.8932 1.06417 12.9358C1.10683 12.9786 1.15383 13 1.20517 13H7.5C7.64189 13 7.76067 13.0479 7.85633 13.1437C7.95211 13.2393 8 13.3581 8 13.5C8 13.6419 7.95211 13.7607 7.85633 13.8563C7.76067 13.9521 7.64189 14 7.5 14H1.20517Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
